const Avalanche = () => (
  <svg fill='none' viewBox='0 0 24 24'>
    <path fill='#E84142' d='M12 24c6.628 0 12-5.372 12-12S18.628 0 12 0 0 5.372 0 12s5.372 12 12 12Z' />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M8.6 16.775H6.27c-.489 0-.73 0-.878-.094a.592.592 0 0 1-.268-.463c-.009-.174.112-.386.354-.81l5.75-10.136c.245-.43.369-.646.525-.725a.593.593 0 0 1 .536 0c.156.08.28.295.525.725l1.182 2.064.006.01c.264.462.398.696.457.942a1.75 1.75 0 0 1 0 .82c-.059.247-.192.483-.46.951l-3.02 5.34-.008.013c-.266.466-.401.702-.588.88a1.758 1.758 0 0 1-.716.416c-.245.067-.52.067-1.067.067Zm5.88 0h3.338c.492 0 .74 0 .887-.097a.59.59 0 0 0 .269-.466c.008-.168-.11-.372-.342-.772a4.694 4.694 0 0 1-.024-.041l-1.672-2.86-.019-.032c-.235-.397-.353-.598-.505-.675a.587.587 0 0 0-.534 0c-.153.08-.277.289-.522.71l-1.665 2.86-.006.01c-.244.42-.366.63-.357.803.012.19.11.363.268.466.145.094.392.094.885.094Z'
      clipRule='evenodd'
    />
  </svg>
)

export { Avalanche }
